(() => {
  const gateway = document.querySelector("[data-whos-gateway]");
  const cursor = document.querySelector(".cursor-dot");

  function bindCookiePreferences() {
    // Public Storefront token already supplied by Shopify; never an Admin token.
    const config = {
      headlessStorefront: true,
      storefrontAccessToken: "09c19237d25fed99806c0b821faf415b",
      checkoutRootDomain: window.location.hostname,
      storefrontRootDomain: window.location.hostname
    };
    let apiPromise, afterSave, saving = false, opening = 0;
    const style = document.createElement("style");
    style.textContent = `
      .gateway-page #shopify-pc__banner{display:none!important}
      .whos-cookie-toggle{position:fixed;left:max(12px,env(safe-area-inset-left));bottom:max(12px,env(safe-area-inset-bottom));z-index:150;min-height:44px;padding:10px 14px;border:1px solid #686863;background:#0f0f0d;color:#f0ede6;font:12px/1.4 Arial,sans-serif;cursor:pointer;touch-action:manipulation}
      .drop-footer.has-cookie-preferences{display:grid;grid-template-columns:minmax(0,1fr) auto auto;align-items:center;column-gap:24px;row-gap:8px}
      .drop-footer .whos-cookie-toggle{position:static;z-index:auto;justify-self:end;min-height:44px;padding:10px 0;border:0;background:transparent;color:inherit;font:inherit;font-size:11px;font-weight:600;text-transform:none;text-decoration:underline;text-underline-offset:3px}
      @media(max-width:720px){.drop-footer.has-cookie-preferences{grid-template-columns:minmax(0,1fr) auto;column-gap:16px}.drop-footer .whos-cookie-toggle{grid-column:1 / -1;grid-row:2;justify-self:start}}
      #WhosCookies{position:fixed;inset:0;margin:auto;width:min(480px,calc(100vw - 32px));max-height:calc(100vh - 32px);max-height:calc(100dvh - 32px);overflow:auto;box-sizing:border-box;padding:24px;background:#0f0f0d;color:#f0ede6;border:1px solid #686863;font:15px/1.5 Arial,sans-serif;text-align:left;z-index:2147483647}
      #WhosCookies::backdrop{background:rgba(0,0,0,.75)}
      #WhosCookies h2{font:700 25px/1.2 Arial,sans-serif;margin:0 0 16px;text-transform:none}
      #WhosCookies p{font:15px/1.5 Arial,sans-serif;margin:12px 0}
      #WhosCookies .cookie-actions{display:grid;gap:10px;margin-top:20px}
      #WhosCookies button{min-height:46px;padding:12px;border:1px solid #85857d;background:#0f0f0d;color:#f0ede6;font:inherit;cursor:pointer;touch-action:manipulation;white-space:normal}
      #WhosCookies button:disabled{opacity:.55;cursor:wait}
      #WhosCookies button:focus-visible,.whos-cookie-toggle:focus-visible{outline:2px solid #f0ede6;outline-offset:3px}
      #WhosCookies label{display:flex;gap:12px;align-items:center;margin:14px 0}
      #WhosCookies input{appearance:auto;width:20px;height:20px;flex:0 0 20px;accent-color:#f0ede6}
      #WhosCookies [data-cookie-status]:empty{display:none}
      #WhosCookies [data-cookie-status]{font-size:13px}
      #WhosCookies .cookie-back{border:none;text-decoration:underline;font-size:13px}
      @media(max-width:420px){#WhosCookies{padding:20px}#WhosCookies h2{font-size:23px}}
    `;
    document.head.appendChild(style);
    const toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "whos-cookie-toggle";
    toggle.textContent = "Cookie preferences";
    toggle.setAttribute("aria-haspopup", "dialog");
    const dialog = document.createElement("dialog");
    dialog.id = "WhosCookies";
    dialog.setAttribute("aria-labelledby", "WhosCookiesTitle");
    dialog.setAttribute("aria-describedby", "WhosCookiesText");
    dialog.innerHTML = `
      <h2 id="WhosCookiesTitle">A quick cookie choice.</h2>
      <p id="WhosCookiesText">We use optional cookies with Shopify and TikTok to understand visits and measure our ads. You can accept them or continue without optional tracking.</p>
      <p>Your email signup is separate. Change your choice any time using Cookie preferences.</p>
      <div data-cookie-details hidden>
        <label><input type="checkbox" checked disabled> Essential — always on</label>
        <label><input type="checkbox" data-consent="analytics"> Analytics</label>
        <label><input type="checkbox" data-consent="marketing"> Marketing and ad measurement</label>
        <label><input type="checkbox" data-consent="preferences"> Personalisation</label>
      </div>
      <div class="cookie-actions">
        <button type="button" data-cookie-action="accept" data-save-consent>Accept optional cookies</button>
        <button type="button" data-cookie-action="decline" data-save-consent>Continue without</button>
        <button type="button" data-cookie-action="manage" aria-expanded="false">Manage preferences</button>
        <button type="button" data-cookie-action="save" data-save-consent hidden>Save choices</button>
      </div>
      <p role="status" aria-live="polite" data-cookie-status></p>
      <button type="button" class="cookie-back" data-cookie-action="close">Back</button>
      <button type="button" data-cookie-action="continue" hidden>Continue to signup</button>`;
    document.body.append(toggle, dialog);
    const message = dialog.querySelector("[data-cookie-status]");
    const details = dialog.querySelector("[data-cookie-details]");
    const manage = dialog.querySelector('[data-cookie-action="manage"]');
    const saveButton = dialog.querySelector('[data-cookie-action="save"]');
    const fallback = dialog.querySelector('[data-cookie-action="continue"]');
    const getApi = () => {
      if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
      if (!apiPromise) apiPromise = new Promise((resolve, reject) => {
        const timer = window.setTimeout(() => reject(new Error("Consent API timed out")), 8000);
        if (!window.Shopify?.loadFeatures) { window.clearTimeout(timer); reject(new Error("Consent API unavailable")); return; }
        window.Shopify.loadFeatures([{name: "consent-tracking-api", version: "0.1"}], error => {
          window.clearTimeout(timer);
          if (error || !window.Shopify.customerPrivacy) reject(error || new Error("Consent API unavailable"));
          else resolve(window.Shopify.customerPrivacy);
        });
      }).catch(error => {apiPromise = undefined; throw error;});
      return apiPromise;
    };
    function finish(continueToForm) {
      const next = afterSave;
      afterSave = undefined;
      opening++;
      dialog.close();
      if (continueToForm && next) next();
    }
    function open(next) {
      if (dialog.open || saving) return;
      afterSave = next;
      const attempt = ++opening;
      details.hidden = true;
      manage.hidden = false;
      manage.setAttribute("aria-expanded", "false");
      saveButton.hidden = true;
      fallback.hidden = true;
      message.textContent = "";
      dialog.querySelectorAll("[data-consent]").forEach(input => {input.checked = false;});
      // Open synchronously on the tap; no third-party popup needs to finish loading.
      dialog.showModal();
      getApi().then(api => {
        if (attempt !== opening || !dialog.open || saving) return;
        const current = api.currentVisitorConsent();
        dialog.querySelectorAll("[data-consent]").forEach(input => {input.checked = current[input.dataset.consent] === "yes";});
      }).catch(() => {
        if (attempt !== opening || !dialog.open) return;
        message.textContent = "Cookie settings are temporarily unavailable. You can retry or continue to signup without changing your existing choice.";
        fallback.hidden = !afterSave;
      });
    }
    dialog.addEventListener("change", () => { opening++; });
    dialog.addEventListener("cancel", event => {
      event.preventDefault();
      if (!saving) finish(false);
    });
    dialog.addEventListener("click", async event => {
      const action = event.target.closest("[data-cookie-action]")?.dataset.cookieAction;
      if (!action || saving) return;
      if (action === "close") {finish(false); return;}
      if (action === "continue") {finish(true); return;}
      if (action === "manage") {
        details.hidden = false;
        manage.setAttribute("aria-expanded", "true");
        manage.hidden = true;
        saveButton.hidden = false;
        return;
      }
      const choices = {};
      dialog.querySelectorAll("[data-consent]").forEach(input => {
        choices[input.dataset.consent] = action === "accept" || (action === "save" && input.checked);
      });
      saving = true;
      dialog.querySelectorAll("button").forEach(button => {button.disabled = true;});
      message.textContent = "Saving your cookie choice…";
      try {
        const api = await getApi();
        await new Promise((resolve, reject) => {
          const timer = window.setTimeout(() => reject(new Error("Consent save timed out")), 8000);
          // Explicit public storefront configuration is required on /password.
          api.setTrackingConsent({...choices, ...config}, result => {
            window.clearTimeout(timer);
            if (result?.error) reject(new Error(result.error));
            else resolve();
          });
        });
        const confirmed = api.currentVisitorConsent();
        if (Object.keys(choices).some(key => confirmed[key] !== (choices[key] ? "yes" : "no"))) throw new Error("Consent not confirmed");
        finish(true);
      } catch (_) {
        message.textContent = "Your new cookie choice was not saved. Please try again. You can still continue to signup without changing your existing choice.";
        fallback.hidden = !afterSave;
      } finally {
        saving = false;
        dialog.querySelectorAll("button").forEach(button => {button.disabled = false;});
      }
    });
    toggle.addEventListener("click", () => open());
    function dock() {
      const footer = gateway?.querySelector(".drop-footer");
      if (!footer) return;
      footer.classList.add("has-cookie-preferences");
      footer.appendChild(toggle);
    }
    return {open, dock};
  }

  const cookiePreferences = bindCookiePreferences();

  function setAppHeight() {
    document.documentElement.style.setProperty("--app-height", `${window.innerHeight}px`);
  }

  function publishEvent(name) {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(name, { path: window.location.pathname });
    }
  }

  function bindProductForm() {
    const root = document.querySelector("[data-product-root]");
    const select = root?.querySelector("[data-variant-select]");
    const variantInput = root?.querySelector("[data-variant-id]");
    const price = root?.querySelector("[data-product-price]");
    const button = root?.querySelector("[data-add-to-cart]");
    if (!select || !variantInput || !button) return;

    const update = () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === "true";
      variantInput.value = option.value;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      button.disabled = !available;
      button.textContent = available ? "Add to bag" : "Unavailable";
    };

    select.addEventListener("change", update);
    update();
  }

  function bindCursor() {
    if (!cursor || window.matchMedia("(pointer: coarse)").matches) return;
    window.addEventListener("pointermove", event => {
      cursor.style.left = `${event.clientX}px`;
      cursor.style.top = `${event.clientY}px`;
    });
    document.querySelectorAll("a, button, input, select").forEach(element => {
      element.addEventListener("pointerenter", () => cursor.classList.add("active"));
      element.addEventListener("pointerleave", () => cursor.classList.remove("active"));
    });
  }

  function bindPrivacyDialog() {
    const dialog = document.querySelector("[data-privacy-dialog]");
    const openers = document.querySelectorAll("[data-privacy-open]");
    const closer = dialog?.querySelector("[data-privacy-close]");
    if (!dialog || !openers.length) return;

    const closeDialog = () => {
      if (dialog.open && typeof dialog.close === "function") dialog.close();
      else dialog.removeAttribute("open");
      document.body.classList.remove("privacy-open");
    };

    openers.forEach(opener => {
      opener.addEventListener("click", event => {
        event.preventDefault();
        if (typeof dialog.showModal === "function") dialog.showModal();
        else dialog.setAttribute("open", "");
        document.body.classList.add("privacy-open");
        closer?.focus();
      });
    });
    closer?.addEventListener("click", closeDialog);
    dialog.addEventListener("cancel", () => document.body.classList.remove("privacy-open"));
    dialog.addEventListener("click", event => {
      if (event.target === dialog) closeDialog();
    });
  }

  if (!gateway) {
    bindPrivacyDialog();
    bindProductForm();
    return;
  }

  const preloader = gateway.querySelector("[data-preloader]");
  const preloadWord = gateway.querySelector("[data-preload-word]");
  const preloadSub = gateway.querySelector("[data-preload-sub]");
  const tagScreen = gateway.querySelector("[data-tag-screen]");
  const dropScreen = gateway.querySelector("[data-drop-screen]");
  const enterButton = gateway.querySelector("[data-enter]");
  const savedSignal = gateway.querySelector("[data-signal-saved]");
  const waitlistState = gateway.querySelector('[data-mode-state="waitlist"]');
  const revealState = gateway.querySelector("[data-reveal-state]");
  const waitIntro = gateway.querySelector("[data-wait-intro]");
  const dropTitle = gateway.querySelector("[data-drop-title]");
  const footerStatus = gateway.querySelector("[data-footer-status]");
  const waitlistForm = gateway.querySelector(".trace-form");
  const formHasErrors = Boolean(waitlistForm?.querySelector(".form-errors"));
  const siteMode = gateway.dataset.siteMode || "waitlist";
  const target = gateway.dataset.countdownTarget || "";
  const signalSaved = savedSignal || new URLSearchParams(window.location.search).get("signal") === "saved";
  const waitlistAttemptKey = "whos_waitlist_attempt_v1";

  function readWaitlistAttempt() {
    try {
      const attempt = JSON.parse(window.sessionStorage.getItem(waitlistAttemptKey));
      const age = Date.now() - attempt?.createdAt;
      return attempt && typeof attempt.id === "string" && age >= 0 && age < 1800000
        ? attempt : null;
    } catch (_) {
      return null;
    }
  }

  function rememberWaitlistAttempt() {
    try {
      const attempt = readWaitlistAttempt();
      const testId = new URLSearchParams(window.location.search).get("tt_test_id");
      const validTestId = /^DAL7N8RC77U9SE5QSJNG_[0-9]{10,13}$/.test(testId || "");
      if (attempt && attempt.path === window.location.pathname) {
        if (validTestId) {
          attempt.tt_test_id = testId;
          window.sessionStorage.setItem(waitlistAttemptKey, JSON.stringify(attempt));
        }
        return;
      }
      window.sessionStorage.setItem(waitlistAttemptKey, JSON.stringify({
        id: window.crypto.randomUUID(),
        createdAt: Date.now(),
        path: window.location.pathname,
        ...(validTestId ? {tt_test_id: testId} : {})
      }));
    } catch (_) {
      // Storage restrictions must never prevent a signup.
    }
  }

  function publishWaitlistSuccess() {
    if (!signalSaved || formHasErrors) return;
    const attempt = readWaitlistAttempt();
    if (!attempt || attempt.path !== window.location.pathname) return;
    try {
      // A recent form submission plus Shopify's success response is required.
      // Shopify's pixel manager enforces tracking consent for subscribers.
      if (window.Shopify?.analytics?.publish?.("whos_waitlist_signup", {
        event_id: attempt.id,
        form_id: waitlistForm?.id,
        path: window.location.pathname,
        ...(/^DAL7N8RC77U9SE5QSJNG_[0-9]{10,13}$/.test(attempt.tt_test_id || "")
          ? {tt_test_id: attempt.tt_test_id} : {})
      })) {
        window.sessionStorage.removeItem(waitlistAttemptKey);
      }
    } catch (_) {
      // Analytics must never interrupt the confirmation screen.
    }
  }
  let countdownTimer;
  let hasEntered = false;

  const preloadSequence = [
    ["WHO?", "unknown signal"],
    ["WHO'S?", "name withheld"],
    ["WH05", "coded label"],
    ["WHO'S DAT?", "question forming"],
    ["WHOS", "WHOS DAT?"]
  ];

  function activateMode(mode) {
    gateway.querySelectorAll("[data-mode-state]").forEach(state => state.hidden = true);
    const activeState = gateway.querySelector(`[data-mode-state="${mode}"]`) || waitlistState;
    if (activeState) activeState.hidden = false;
    if (mode === "countdown") startCountdown();
  }

  function updateCountdown() {
    const clock = gateway.querySelector("[data-countdown-clock]");
    if (!clock) return;
    const targetTime = Date.parse(target);
    if (!Number.isFinite(targetTime)) {
      clock.textContent = "? ? : ? ? : ? ? : ? ?";
      return;
    }
    const remaining = Math.max(0, targetTime - Date.now());
    const values = [
      Math.floor(remaining / 86400000),
      Math.floor((remaining % 86400000) / 3600000),
      Math.floor((remaining % 3600000) / 60000),
      Math.floor((remaining % 60000) / 1000)
    ];
    clock.textContent = values.map(value => String(value).padStart(2, "0")).join(" : ");
  }

  function startCountdown() {
    window.clearInterval(countdownTimer);
    updateCountdown();
    countdownTimer = window.setInterval(updateCountdown, 1000);
  }

  function revealSavedSignal() {
    publishWaitlistSuccess();
    activateMode("waitlist");
    if (dropTitle) {
      dropTitle.textContent = gateway.dataset.confirmationHeadline || "You made the right choice.";
    }
    waitIntro?.setAttribute("hidden", "");
    gateway.querySelector(".trace-form")?.setAttribute("hidden", "");
    revealState?.removeAttribute("hidden");
    if (footerStatus) footerStatus.textContent = "Signal closed";
    dropScreen?.classList.add("is-confirmed", "is-revealing");
  }

  function showDrop({ immediate = false } = {}) {
    if (hasEntered) return;
    hasEntered = true;
    enterButton?.classList.remove("is-pressing");
    publishEvent("whos_enter");

    const finish = () => {
      if (tagScreen) tagScreen.hidden = true;
      if (dropScreen) dropScreen.hidden = false;
      cookiePreferences.dock();
      activateMode(siteMode);
      if (signalSaved) revealSavedSignal();
      window.scrollTo({ top: 0, behavior: "auto" });
    };

    if (immediate) {
      finish();
      return;
    }
    tagScreen?.classList.add("fade-out");
    window.setTimeout(finish, 430);
  }

  function runPreloader() {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!preloader || reducedMotion) {
      document.body.classList.remove("loading");
      if (signalSaved || formHasErrors) showDrop({ immediate: true });
      return;
    }
    preloadSequence.forEach(([word, sub], index) => {
      window.setTimeout(() => {
        if (preloadWord) preloadWord.textContent = word;
        if (preloadSub) preloadSub.textContent = sub;
      }, index * 230);
    });
    window.setTimeout(() => {
      preloader.classList.add("done");
      preloader.setAttribute("aria-hidden", "true");
      document.body.classList.remove("loading");
      if (signalSaved || formHasErrors) showDrop({ immediate: true });
    }, preloadSequence.length * 230 + 480);
  }

  document.body.classList.add("loading");
  setAppHeight();
  bindCursor();
  bindPrivacyDialog();
  enterButton?.setAttribute("aria-label", "Enter");
  enterButton?.addEventListener("click", () => {
    if (!hasEntered) cookiePreferences.open(() => showDrop());
  });
  function bindWaitlistSubmission() {
    if (!waitlistForm) return;
    const submitButton = waitlistForm.querySelector('button[type="submit"]');
    if (!submitButton) return;
    const buttonLabel = submitButton.textContent;
    const status = document.createElement("div");
    status.className = "form-errors";
    status.setAttribute("role", "status");
    status.setAttribute("aria-live", "polite");
    status.setAttribute("aria-atomic", "true");
    status.hidden = true;
    waitlistForm.append(status);
    let submissionTimer;

    const reset = () => {
      window.clearTimeout(submissionTimer);
      submitButton.disabled = false;
      submitButton.textContent = buttonLabel;
      status.hidden = true;
      status.textContent = "";
    };

    waitlistForm.addEventListener("submit", () => {
      if (!waitlistForm.checkValidity()) return;
      rememberWaitlistAttempt();
      window.clearTimeout(submissionTimer);
      // Shopify may pause submission for CAPTCHA and click the submitter again.
      // Keep that button enabled and leave submission entirely to Shopify.
      status.hidden = false;
      status.textContent = "Submitting your signup. Please complete any verification shown.";
      submissionTimer = window.setTimeout(() => {
        status.textContent = "Your signup has not been confirmed. Complete any verification shown, check your connection, then try Save signal again.";
      }, 15000);
    });
    waitlistForm.addEventListener("input", reset);
    window.addEventListener("pageshow", reset);
    window.addEventListener("pagehide", () => window.clearTimeout(submissionTimer));
  }
  bindWaitlistSubmission();
  window.addEventListener("resize", setAppHeight);
  window.addEventListener("orientationchange", () => window.setTimeout(setAppHeight, 250));
  window.addEventListener("pagehide", () => window.clearInterval(countdownTimer));
  runPreloader();
})();

;
// WHOS SMS signup — Klaviyo public client API; no private credentials.
(() => {
  if (!document.body.classList.contains('password-page') || document.getElementById('WhosSms')) return;
  const companyId = 'VdqHbC';
  const listId = 'XpVCeM';
  const termsUrl = 'https://whos-dat.myklpages.com/p/mobile-terms-of-service';
  const privacyUrl = 'https://whosd4t.com/password?privacy=1';
  // A short-lived, same-tab handoff connects the two signup steps. Keep this
  // contact detail out of URLs, analytics, and the tracking attempt record.
  const emailKey = 'whos_sms_email_handoff_v1';
  const emailForm = document.getElementById('PasswordWaitlistForm');
  const emailInput = document.getElementById('PasswordWaitlistEmail');
  const emailSaved = Boolean(document.querySelector('[data-signal-saved]')) &&
    !document.querySelector('.form-errors:not([hidden])');
  let signupEmail = '';
  try {
    const handoff = JSON.parse(window.sessionStorage.getItem(emailKey));
    const age = Date.now() - handoff?.createdAt;
    if (emailSaved && age >= 0 && age < 1200000 &&
        handoff?.path === window.location.pathname && typeof handoff.email === 'string') {
      signupEmail = handoff.email;
    }
    window.sessionStorage.removeItem(emailKey);
  } catch (_) { /* Manual email entry remains available when storage is blocked. */ }
  emailForm?.addEventListener('submit', () => {
    try {
      window.sessionStorage.removeItem(emailKey);
      if (emailInput?.value.trim() && emailForm.checkValidity()) {
        window.sessionStorage.setItem(emailKey, JSON.stringify({
          email: emailInput.value.trim(), createdAt: Date.now(), path: window.location.pathname
        }));
      }
    } catch (_) { /* Never interrupt Shopify's native email signup. */ }
  });
  const style = document.createElement('style');
  style.textContent = `
    #WhosSms{box-sizing:border-box;width:min(520px,calc(100% - 28px));max-height:calc(100dvh - 28px);overflow:auto;padding:28px;border:1px solid #706e67;background:#f3f0e8;color:#151512;font:15px/1.5 Arial,sans-serif;color-scheme:light}
    #WhosSms::backdrop{background:rgba(0,0,0,.76)}
    #WhosSms *{box-sizing:border-box}#WhosSms [hidden],.whos-sms-offer[hidden]{display:none!important}
    #WhosSms h2{margin:14px 0 10px;font-size:29px;line-height:1.15;color:inherit;letter-spacing:-.7px}
    #WhosSms p{font:inherit;margin:10px 0;color:inherit;max-width:none}
    #WhosSms .sms-top{display:flex;justify-content:space-between;align-items:center;gap:16px;font-size:12px;letter-spacing:1px}
    #WhosSms button{min-height:44px;border:1px solid #55534e;background:#151512;color:#f3f0e8;padding:10px 16px;font:inherit;cursor:pointer;touch-action:manipulation}
    #WhosSms button:disabled{opacity:.6;cursor:wait}
    #WhosSms .sms-close{background:transparent;color:#151512;border:0;text-decoration:underline;padding:8px}
    #WhosSms label{display:block;margin-top:18px;font-size:14px;line-height:1.5;letter-spacing:0;text-transform:none}
    #WhosSms input[type=tel],#WhosSms input[type=email]{display:block;width:100%;min-height:48px;border:1px solid #77746b;background:#fff;color:#151512;padding:12px;margin-top:6px;font:16px Arial,sans-serif}
    #WhosSms .sms-consent{display:flex;gap:10px;align-items:flex-start;margin:18px 0}
    #WhosSms input[type=checkbox]{width:19px;height:19px;flex:0 0 19px;margin:3px 0;accent-color:#151512}
    #WhosSms a{color:inherit;text-decoration:underline}#WhosSms [type=submit]{width:100%}
    #WhosSms :focus-visible,.whos-sms-offer :focus-visible{outline:3px solid #9c7350;outline-offset:3px}
    #WhosSms .sms-help{font-size:12px}#WhosSms [data-sms-status]{font-size:14px}
    .whos-sms-offer{margin-top:24px;padding-top:20px;border-top:1px solid currentColor;font:14px/1.5 Arial,sans-serif}
    .whos-sms-offer button{min-height:44px;padding:10px 16px;font:inherit;cursor:pointer;touch-action:manipulation;background:#f3f0e8;color:#151512;border:1px solid #77746b}
    .whos-sms-offer .sms-skip{background:transparent;color:inherit;border:0;text-decoration:underline}
  `;
  document.head.append(style);

  // The storefront is password protected, so expose the existing policy in its
  // dialog instead of linking visitors to Shopify's redirected policy route.
  const privacy = document.querySelector('[data-privacy-dialog]');
  if (privacy) {
    document.body.append(privacy);
    const section = document.createElement('section');
    section.innerHTML = `<h3>WHOS SMS</h3><p>If you choose to join WHOS SMS, we use your mobile number and consent record to send product drop alerts, giveaway updates and marketing offers through Klaviyo. Signing up for texts is optional and separate from email signup.</p><p>Klaviyo and messaging delivery providers process your number, consent and delivery information to run this service. We do not sell your mobile number or share SMS consent with other businesses for their own marketing. We retain consent and unsubscribe records as needed to honour your choices and meet applicable obligations.</p><p>Use the unsubscribe link in any text to stop marketing messages. For help or to request access to or deletion of your information, email <a href="mailto:info@whosd4t.com">info@whosd4t.com</a>. Message frequency varies. Message and data rates may apply. Read our <a href="${termsUrl}" target="_blank" rel="noopener">Mobile Terms</a>.</p>`;
    privacy.querySelector('.privacy-dialog__content')?.append(section);
  }
  const openPrivacy = () => {
    if (!privacy || privacy.open) return;
    privacy.showModal();
    document.body.classList.add('privacy-open');
    privacy.querySelector('[data-privacy-close]')?.focus();
  };

  const dialog = document.createElement('dialog');
  dialog.id = 'WhosSms';
  dialog.setAttribute('aria-labelledby', 'WhosSmsTitle');
  dialog.innerHTML = `<div class="sms-top"><span>WHOS DAT?</span><button type="button" class="sms-close" data-sms-close aria-label="Close SMS signup">Close</button></div><h2 id="WhosSmsTitle">Get the drop by text.</h2><p>Join WHOS SMS for drop alerts and giveaway updates. Stay close.</p><form data-sms-form><label for="WhosSmsPhone">UK mobile number<input id="WhosSmsPhone" type="tel" inputmode="tel" autocomplete="tel" placeholder="+44 7..." required maxlength="24" aria-describedby="WhosSmsHelp"></label><p class="sms-help" id="WhosSmsHelp">UK mobile numbers only. Signing up does not require a reply or confirmation code.</p><label class="sms-consent"><input type="checkbox" required data-sms-consent><span>Yes, send me recurring automated WHOS DAT? marketing texts about drops, giveaways and offers. Consent is optional and is not a condition of purchase. Message frequency varies. Message and data rates may apply. Unsubscribe using the link in any message.</span></label><p class="sms-help">By joining, you agree to our <a href="${termsUrl}" target="_blank" rel="noopener">Mobile Terms</a>. See our <a href="${privacyUrl}" data-sms-privacy>Privacy Policy</a>. Help: <a href="mailto:info@whosd4t.com">info@whosd4t.com</a>.</p><button type="submit">Join WHOS SMS</button></form><p data-sms-status role="status" aria-live="polite" aria-atomic="true"></p>`;
  document.body.append(dialog);
  const form = dialog.querySelector('form');
  const phone = dialog.querySelector('[type=tel]');
  const emailLabel = document.createElement('label');
  emailLabel.htmlFor = 'WhosSmsEmail';
  emailLabel.innerHTML = 'Email address (optional)<input id="WhosSmsEmail" type="email" autocomplete="email" inputmode="email" maxlength="254" aria-describedby="WhosSmsEmailHelp"><span class="sms-help" id="WhosSmsEmailHelp">Use your waitlist email to keep your email and mobile number together. Your email subscription choice stays the same.</span>';
  form.prepend(emailLabel);
  const linkedEmail = dialog.querySelector('#WhosSmsEmail');
  linkedEmail.value = signupEmail;
  if (linkedEmail.value && !linkedEmail.checkValidity()) linkedEmail.value = '';
  signupEmail = '';
  const consent = dialog.querySelector('[data-sms-consent]');
  const submit = dialog.querySelector('[type=submit]');
  const status = dialog.querySelector('[data-sms-status]');
  let pending = false;
  const openSms = () => {
    if (!dialog.open) dialog.showModal();
    phone.focus();
  };
  dialog.querySelector('[data-sms-close]').addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-sms-privacy]').addEventListener('click', event => {
    if (privacy) { event.preventDefault(); openPrivacy(); }
  });
  phone.addEventListener('input', () => phone.setCustomValidity(''));
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (pending || !form.reportValidity() || !consent.checked) return;
    let number = phone.value.trim().replace(/[\s().-]/g, '');
    if (number.startsWith('0044')) number = '+' + number.slice(2);
    if (/^07\d{9}$/.test(number)) number = '+44' + number.slice(1);
    if (/^447\d{9}$/.test(number)) number = '+' + number;
    if (!/^\+447[1-57-9]\d{8}$/.test(number)) {
      phone.setCustomValidity('Enter a UK mobile number beginning 07 or +44 7.');
      phone.reportValidity();
      return;
    }
    pending = true;
    submit.disabled = true;
    submit.textContent = 'Sending request...';
    status.textContent = 'Submitting your SMS signup.';
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${companyId}`, {
        method: 'POST', credentials: 'omit', signal: controller.signal,
        headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-07-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'WHOS website SMS signup - disclosure 2026-09-17',
          profile: { data: { type: 'profile', attributes: { phone_number: number,
            ...(linkedEmail.value.trim() ? { email: linkedEmail.value.trim() } : {}),
            subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        }, relationships: { list: { data: { type: 'list', id: listId } } } } })
      });
      if (response.status !== 202) throw new Error(response.status === 429 ? 'rate-limited' : 'not-accepted');
      // 202 is acceptance for processing, never proof of confirmed consent or delivery.
      status.textContent = "Request received. Your number is being added to WHOS SMS. No confirmation reply is needed. You can close this window.";
      form.hidden = true;
      phone.value = '';
      linkedEmail.value = '';
      consent.checked = false;
    } catch (error) {
      status.textContent = error.message === 'rate-limited'
        ? 'Please wait a few minutes before trying again. Your email signup is unchanged.'
        : "We couldn't confirm this request. Check your phone before retrying, or email info@whosd4t.com for help. Your email signup is unchanged.";
    } finally {
      window.clearTimeout(timer);
      pending = false;
      submit.disabled = false;
      submit.textContent = 'Join WHOS SMS';
    }
  });

  if (document.querySelector('[data-signal-saved]') && !document.querySelector('.form-errors')) {
    const reveal = document.querySelector('[data-reveal-state]');
    if (reveal) {
      const offer = document.createElement('div');
      offer.className = 'whos-sms-offer';
      offer.innerHTML = '<button type="button" data-sms-open>Get the drop by text</button> <button type="button" class="sms-skip">Skip</button>';
      reveal.after(offer);
      offer.querySelector('[data-sms-open]').addEventListener('click', openSms);
      offer.querySelector('.sms-skip').addEventListener('click', () => { offer.hidden = true; });
    }
  }
  const params = new URLSearchParams(window.location.search);
  if (params.get('privacy') === '1') openPrivacy();
  else if (params.get('sms') === '1') openSms();
})();
// Keep Shopify's native submission and verification; expose validation inline.
(() => {
  const form = document.getElementById('PasswordWaitlistForm');
  const email = document.getElementById('PasswordWaitlistEmail');
  const permission = document.getElementById('PasswordWaitlistPermission');
  if (!form || !email || !permission || form.dataset.whosFeedback) return;
  form.dataset.whosFeedback = 'true';
  // Prepare Shopify verification before a quick autofill-and-submit on mobile.
  // Keep all token handling and submission with Shopify.
  if (!form.dataset.cptcha && window.Shopify?.captcha?.protect) {
    try { window.Shopify.captcha.protect(form); } catch (_) { /* Native wiring remains available. */ }
  }
  const button = form.querySelector('button[type="submit"]');
  const buttonLabel = button?.textContent || 'Save signal';
  let progressTimer;
  let feedback = form.querySelector('.form-errors[role="status"]');
  if (!feedback) {
    feedback = document.createElement('p');
    feedback.className = 'form-errors';
    feedback.setAttribute('role', 'status');
    feedback.setAttribute('aria-live', 'polite');
    feedback.hidden = true;
    form.append(feedback);
  }
  feedback.id = 'WhosEmailFeedback';
  for (const field of [email, permission]) {
    const ids = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
    ids.add(feedback.id);
    field.setAttribute('aria-describedby', [...ids].join(' '));
  }
  form.addEventListener('invalid', () => {
    feedback.hidden = false;
    feedback.textContent = !email.validity.valid
      ? 'Enter a valid email address to save your signal.'
      : 'Tick the email permission box above, then tap Save signal.';
  }, true);
  const clear = () => {
    window.clearTimeout(progressTimer);
    if (button) button.textContent = buttonLabel;
    feedback.hidden = true; feedback.textContent = '';
  };
  form.addEventListener('input', clear);
  form.addEventListener('change', clear);
  form.addEventListener('submit', () => {
    if (!form.checkValidity()) return;
    window.clearTimeout(progressTimer);
    if (button) button.textContent = 'Saving signal...';
    feedback.hidden = false;
    feedback.textContent = 'Submitting your signup. Complete any verification shown.';
    progressTimer = window.setTimeout(() => {
      if (button) button.textContent = 'Try Save signal again';
      feedback.hidden = false;
      feedback.textContent = 'Your signup has not been confirmed. Complete any verification, then tap Try Save signal again. If it still gets stuck, email info@whosd4t.com.';
    }, 16000);
  });
  window.addEventListener('pageshow', clear);
  window.addEventListener('pagehide', () => window.clearTimeout(progressTimer));
  const style = document.createElement('style');
  style.textContent = '#PasswordWaitlistForm .trace-consent{min-height:44px;font-size:14px;line-height:1.5;align-items:center;cursor:pointer}#PasswordWaitlistPermission{width:22px;height:22px;flex:0 0 22px;cursor:pointer}#WhosEmailFeedback{font-size:14px;line-height:1.5;margin-top:12px}';
  document.head.append(style);
})();
